import { RejectionReasonsEnum } from "./enums";

const STORAGE_KEY = "missedOrDeclinedCallDataList";
const NG_STORAGE_USER = "ngStorage-user";

interface StoredCallData {
  callId: string;
  reason: string;
  emrUserId: string;
}

export const getAutoDeclinedCalls = (): StoredCallData[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const addDeclinedCallInStorage = (
  callId: string,
  reason: RejectionReasonsEnum
) => {
  const emrUserId = getCurrentEmrUserId();
  const updated: StoredCallData[] = [{ callId, reason, emrUserId }];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
};

export const removeDeclinedCallFromStorage = (callId: string) => {
  const existing = getAutoDeclinedCalls().filter(
    (item) => item.callId !== callId
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
};

export const getUserDeclinedCalls = (emrUserId?: string): StoredCallData[] => {
  const id = emrUserId || getCurrentEmrUserId();
  return getAutoDeclinedCalls().filter((item) => item.emrUserId === id);
};

function getCurrentEmrUserId(): string {
  try {
    const user = JSON.parse(localStorage.getItem(NG_STORAGE_USER) || "{}");
    return user.id ? String(user.id) : "";
  } catch {
    return "";
  }
}
